// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blog-module--wrapper--2BNRD","heading":"blog-module--heading--1VP0F"};